import React, { Component } from 'react'
import { getInformationWithData } from '../../services/CABE.js'
import { getValueCookie } from '../../services/cookieService';
import LoadingWindow from '../LoadingWindow';
import { getIndexElement } from '../../functions/searchInObject';
//import { v4 as uuidv4 } from 'uuid';
import { BsArrowRepeat, BsJournals, BsList } from "react-icons/bs";
import { FiRefreshCw } from 'react-icons/fi';
//import { pricesFormat } from '../../functions/pricesFormat';
import ModalOrders from '../ModalComponent';
import { Item, productLine } from './Class';
import { pricesFormat } from '../../functions/pricesFormat.js';
import ItemCard from './ItemCard.js';
import { confirmCloseAlert } from '../../functions/alerts';
// Styles
import "../../css/general-style.css";
import "../../css/scrollBar.css";


// Funciones auxiliares para validar las imagenes en cache
const THUMBS_CACHE_NAME = 'mayaland-thumbs-v9';   // Debe coincidir con el SW
const THUMBS_TTL_MS = 12 * 60 * 60 * 1000;        // 12h
const THUMBS_LAST_TS_KEY = 'thumbs:last_ts';

async function hasThumbsInCache() {
  if (!('caches' in window)) return false;
  try {
    const cache = await caches.open(THUMBS_CACHE_NAME);
    const keys = await cache.keys();
    return keys.length > 0;
  } catch { return false; }
}

async function swReady() {
  if (!('serviceWorker' in navigator)) return false;
  try {
    const reg = await navigator.serviceWorker.ready;
    return !!reg.active;
  } catch { return false; }
}

// Clase de catalogo
export default class CatalogueV2 extends Component {
  constructor(props) {
    super(props);
    this.retornarProducto = React.createRef();
    this.ModalLoading = React.createRef();
  }
  // Offline global variables
  OFFLINE_CACHE_DURATION_MS = 10 * 60 * 1000; // 10 minutos

  state = {
    Catalogo: [],
    ProductsInSearch: [],
    ProductosMostrados: [],
    ProductLine: [],
    ProductLineMostrados: [],
    oldPriceLevel: '',
    showModal: false,
    SelectedProdLine: 'All',
    currentPage: 0,
    ProductsPerPage: 60,
    TotalPages: 0,
    oldCustomerNo: '',
    talpaCatalog: []

  }

  componentDidMount() {
    // Precarga al montar si hay internet
    this.prefetchProductsOffline();

    // Validar las imagenes en cache
    this.ensureThumbsCached();

    // Cuando vuelva el internet, intenta precargar de nuevo
    // (evita que el vendedor tenga que abrir el catálogo manualmente)
    this._onOnline = () => this.prefetchProductsOffline();
    window.addEventListener('online', this._onOnline);
  }

  componentWillUnmount() {
    if (this._onOnline) {
      window.removeEventListener('online', this._onOnline);
    }
  }

  ensureThumbsCached = async () => {
    if (!navigator.onLine) return; // sólo precarga online
    const ready = await swReady();
    if (!ready) return;

    const last = parseInt(localStorage.getItem(THUMBS_LAST_TS_KEY) || '0', 10);
    const fresh = Date.now() - last < THUMBS_TTL_MS;

    const hasCache = await hasThumbsInCache();

    // Primera vez (sin caché) o TTL vencido → precargar
    if (!hasCache || !fresh) {
      await this.refreshThumbsCache();             // tu función existente
      localStorage.setItem(THUMBS_LAST_TS_KEY, String(Date.now()));
    }
  };

  clearAll() {
    this.setState({
      Catalogo: [],
      ProductosMostrados: [],
      ProductLine: [],
      // ProductLineMostrados: [], // Se mantiene para evitar problemas de renderizado
      oldPriceLevel: '',
      SelectedProdLine: 'All',
      talpaCatalog: []

    })
  }

  handleModalOpen = () => {
    this.setState({ showModal: true })
  }

  handleModalClose = () => {
    this.setState({ showModal: false })
    this.clearAll()
  }

  getPriceLevel() {
    if (this.props.PriceLevel) {
      this.setState({ oldPriceLevel: this.props.PriceLevel })
      return this.props.PriceLevel
    } else {
      this.setState({ oldPriceLevel: this.props.PriceLevel })
      return undefined
    }
  }



  buscarProductos = async e => {
    let search = e.target.value;

    if (search.length >= 3 || search.length === 0) {
      if (this.state.SelectedProdLine !== 'All') {
        if (search !== '') {
          let Products = this.state.Catalogo.filter((item) => {
            if (
              (this.contiene(item.itemCode, search) ||
                this.contiene(item.abbreviatedDesc, search)) && (this.contiene(item.ProductLineDesc, this.state.SelectedProdLine))

            ) {
              return item
            } else {
              return null
            }
          })
          this.setState({ ProductsInSearch: Products });
        } else {
          let Products = this.state.Catalogo.filter((item) => {
            if (this.contiene(item.ProductLineDesc, this.state.SelectedProdLine)) {
              return item
            } else {
              return null
            }
          })
          this.setState({ ProductsInSearch: Products });
        }

      } else {
        if (search !== '') {
          let Products = this.state.Catalogo.filter((item) => {
            if (
              this.contiene(item.itemCode, search) ||
              this.contiene(item.abbreviatedDesc, search)
            ) {
              return item
            } else {
              return null
            }
          })
          this.setState({ ProductsInSearch: Products });
        } else {
          this.setState({ ProductsInSearch: this.state.Catalogo });
        }

      }
    }

    await this.ResetPagination();
  }

  SearchLineProduct = e => {
    let search = e.target.value
    if (search !== '') {
      let ProductLines = this.state.ProductLine.filter((prodLine) => {
        if (this.contiene(prodLine.ProductLineName, search)) {
          return prodLine
        } else {
          return null
        }
      })

      this.setState({ ProductLineMostrados: ProductLines })
    } else {
      this.setState({ ProductLineMostrados: this.state.ProductLine })
    }

  }

  contiene(parametro, busqueda) {
    if (parametro && busqueda) {
      return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
    } else {
      return false
    }

  }
  getCustomerNo() {

    if (this.props.Customer.CustomerNo) {
      this.setState({ oldCustomerNo: this.props.Customer.CustomerNo })
    } else {
      this.setState({ oldCustomerNo: '' })
    }

  }

  async SelectProductLine(prodLine) {
    if (prodLine.ProductLineName !== 'All') {
      const catalogo = this.state.Catalogo
      let catalogoProductLine = []
      for (const item of catalogo) {

        if (item.ProductLineDesc === prodLine.ProductLineName) {
          catalogoProductLine.push(item)
        }
      }

      // Mantiene el renderizado de product line
      this.setState({ ProductsInSearch: catalogoProductLine, SelectedProdLine: prodLine.ProductLineName }, () => this.ResetPagination());
    } else {
      const catalogo = this.state.Catalogo
      // Mantiene el renderizado de product line
      this.setState({ ProductsInSearch: catalogo, SelectedProdLine: 'All' }, () => this.ResetPagination());
    }
  }

  setAltPrice(item) {
    let altitudePrice = item.LastTotalUnitCost / 0.95;
    altitudePrice = altitudePrice / (1 - (item.MarkUp / 100));
    if (altitudePrice < item.UnitPrice) {
      altitudePrice = item.UnitPrice
    }

    // Temporal solution for new clients for Atlitude to add 10% 
    // if (getValueCookie('SalesPerson') === 'FS') {
    //   altitudePrice = (item.LastTotalUnitCost / 0.95) / 0.90;
    // }

    return altitudePrice;
  }

  async setTalpaPrice(fullCatalog) {
    const data = {
      companyId: '3',
      priceLevel: '6',
    }
    const productsReponse = await getInformationWithData('/Items/getListV2', data);
    const talpaProducts = productsReponse.data

    // Remplazar los productos Talpa con el catalogo original
    const mergedProducts = fullCatalog.map(item => {
      const updatedItem = talpaProducts.find(t => t.itemCode === item.itemCode);
      if (updatedItem) {
        return { ...item, ...updatedItem }
      } else {
        return item
      }
    })

    return mergedProducts
  }

  // Offline helper functions
  getCompanyScope() {
    var sub = getValueCookie('SubCompanyId');
    var cmp = getValueCookie('CompanyId');
    return sub && sub !== '' ? String(sub) : String(cmp);
  }

  buildProductsCacheKey(props) {
    var version = 'v1.2';
    var companyId = this.getCompanyScope();
    return 'products:' + version + ':' + companyId;
  }

  tsKeyFor(dataKey) {
    return dataKey + ':ts';
  }

  // dentro de la clase CatalogueV2 (no en el constructor)
  refreshThumbsCache = async () => {
    try {
      // START UI
      if (this.props && this.props.Padre && typeof this.props.Padre.setState === 'function') {
        this.props.Padre.setState({ syncImagesStatus: 'started' });
      }
      if (typeof this.setState === 'function') {
        this.setState({ thumbsMessage: 'Refreshing offline images…', isRefreshingThumbs: true });
      }

      if (!navigator.onLine) throw new Error('You are offline. Connect to refresh.');
      if (!('serviceWorker' in navigator)) throw new Error('Service Worker unavailable.');

      const reg = await navigator.serviceWorker.ready;
      const sw = (reg && reg.active) ? reg.active : null;
      if (!sw) throw new Error('Service Worker not active yet.');

      const ORIGIN = 'https://mayaland-src.s3.us-east-2.amazonaws.com/';
      const items = (this.state && this.state.Catalogo) ? this.state.Catalogo : [];

      // URLs (thumb fallback), codificadas y filtradas por ORIGIN
      var urls = [];
      for (var i = 0; i < items.length; i++) {
        var raw = items[i].itemURLImageThumb || items[i].itemURLImage;
        if (!raw) continue;
        var u = encodeURI(raw);
        if (u.indexOf(ORIGIN) === 0) urls.push(u);
      }
      urls = Array.from(new Set(urls));
      // Si quieres respetar tope del SW, descomenta y ajusta:
      // urls = urls.slice(0, 900);

      var jobId = 'thumbs-' + Date.now();

      await new Promise((resolve) => {
        var self = this;

        function onMsg(ev) {
          var d = ev.data || {};
          if (d.jobId !== jobId) return;

          if (d.type === 'PRECACHE_PROGRESS') {
            var pct = d.total ? Math.round((d.done / d.total) * 100) : 0;
            if (typeof self.setState === 'function') {
              self.setState({ thumbsMessage: 'Caching ' + d.done + '/' + d.total + ' images (' + pct + '%)…' });
            }
          }

          if (d.type === 'PRECACHE_DONE') {
            if (self.props && self.props.Padre && typeof self.props.Padre.setState === 'function') {
              self.props.Padre.setState({ syncImagesStatus: 'done' });
            }
            if (typeof self.setState === 'function') {
              self.setState({ thumbsMessage: 'Offline images ready. (' + d.ok + '/' + d.total + ')', isRefreshingThumbs: false });
            }
            navigator.serviceWorker.removeEventListener('message', onMsg);
            setTimeout(function () {
              if (self && typeof self.setState === 'function') self.setState({ thumbsMessage: '' });
            }, 3000);
            resolve();
          }
        }

        navigator.serviceWorker.addEventListener('message', onMsg);
        sw.postMessage({ type: 'PRECACHE_THUMBS', urls: urls, jobId: jobId });
      });

    } catch (e) {
      var msg = (e && e.message) ? e.message : 'Failed to refresh offline images.';
      if (this.props && this.props.Padre && typeof this.props.Padre.setState === 'function') {
        this.props.Padre.setState({ syncImagesStatus: 'done' });
      }
      if (typeof this.setState === 'function') {
        this.setState({ thumbsMessage: msg, isRefreshingThumbs: false });
      }
    }
  };


  hasValidCacheAge(key) {
    var ts = localStorage.getItem(this.tsKeyFor(key));
    if (!ts) return false;
    var last = parseInt(ts, 10);
    if (isNaN(last)) return false;
    return (Date.now() - last) < this.OFFLINE_CACHE_DURATION_MS;
  }

  // Ajusta los campos mínimos según tu render (itemCode, UnitPrice, desc, etc.)
  isProductShapeValid(arr) {
    if (!arr || !arr.length) return false;
    // valida el primero (y opcionalmente algunos más)
    var p = arr[0];
    return !!(p &&
      p.itemCode &&
      (p.abbreviatedDesc || p.completeDesc) &&
      (p.UnitPrice !== undefined) &&
      (p.ShipWeight !== undefined) &&
      (p.ProductLine !== undefined));
  }

  loadOfflineProducts(key) {
    var raw = localStorage.getItem(key);
    if (!raw) return null;
    try {
      const parsedProducts = JSON.parse(raw);
      var products = [];
      console.log("-  loadOfflineProducts")
      // console.log(parsedProducts[0])
      for (let i = 0; i < parsedProducts.length; i++) {
        const p = parsedProducts[i];
        products.push(new Item(
          p.itemCode,
          p.abbreviatedDesc,
          p.upc,
          p.quantity,
          p.ShipWeight,
          p.StandardUnitCost,
          p.LastTotalUnitCost,
          p.UnitPrice,
          p.ProductLine,
          p.ProductLineDesc,
          p.upc2,
          p.caseupc,
          p.itemURLImage,
          p.InputValue,
          p.IdCompany
        ));
      }

      return products;
    } catch (e) {
      console.error('Failed to parse offline products', e);
      return null;
    }
  }

  isExpired(ts) {
    if (!ts) return true;
    var last = parseInt(ts, 10);
    if (isNaN(last)) return true;
    return (Date.now() - last) > this.OFFLINE_CACHE_DURATION_MS;
  }

  saveOfflineProducts(key, products) {
    try {
      localStorage.setItem(key, JSON.stringify(products));
      localStorage.setItem(this.tsKeyFor(key), String(Date.now()));
    } catch (e) {
      console.error('Failed to save offline products', e);
    }
  }

  // Set all props to products
  toPlainProduct(item) {
    return {
      itemCode: item.itemCode,
      abbreviatedDesc: item.abbreviatedDesc,
      completeDesc: item.completeDesc,
      upc: item.upc,
      upc2: item.upc2,
      caseupc: item.caseupc,
      quantity: item.quantity,
      ShipWeight: item.ShipWeight,
      StandardUnitCost: item.StandardUnitCost,
      LastTotalUnitCost: item.LastTotalUnitCost,
      UnitPrice: item.UnitPrice,
      ProductLine: item.ProductLine,
      ProductLineDesc: item.ProductLineDesc,
      itemURLImage: item.itemURLImage,
      IdCompany: item.IdCompany,
      InputValue: item.InputValue ? item.InputValue : 0,
      Visible: item.Visible !== undefined ? item.Visible : 1
    };
  }

  // Set all products with origin struct
  fromPlainToItem(p) {
    // Usa exactamente el mismo orden/constructor que ya tienes
    return new Item(
      p.itemCode,
      (p.completeDesc && p.completeDesc !== "null") ? p.completeDesc : p.abbreviatedDesc,
      p.upc,
      p.quantity,
      p.ShipWeight,
      p.StandardUnitCost,
      p.LastTotalUnitCost,
      p.UnitPrice,
      p.ProductLine,
      p.ProductLineDesc,
      p.upc2,
      p.caseupc,
      p.itemURLImage,
      p.InputValue ? p.InputValue : 0,
      p.IdCompany
    );
  }

  // Usar offline solo si NO hay internet, o hay internet y el cache es válido y no se pidió refresh.
  shouldUseOffline(isOnline, refresh, cacheValid) {
    if (!isOnline) return true;              // sin internet => offline
    if (refresh) return false;               // se pidió refresh explícito => online
    return cacheValid;                       // online + cache válido => offline
  }

  // Precarga catálogos para uso offline sin tocar la UI
  prefetchProductsOffline = async () => {
    // Solo precargar si hay internet
    if (!this.props.isOnline) return;

    var cacheKey = this.buildProductsCacheKey(this.props);

    // Si el cache aún es válido, no hagas nada
    // var ts = localStorage.getItem(this.tsKeyFor(cacheKey));
    
    // CHANGE THIS BEFORE PROD <---
    // if (ts && !this.isExpired(ts)) return;

    // Validar price level dependiendo del componente padre
    let priceLevelValidation = this.getPriceLevel();
    let priceLevelValue = '1';
    if (priceLevelValidation && !this.props.PriceLevel) {
      priceLevelValue = priceLevelValidation;
    }
    if (!priceLevelValidation && this.props.PriceLevel) {
      priceLevelValue = this.props.PriceLevel;
    }
    // Validar customer no dependiendo del componente padre
    let customerNoValue = '0000000';
    if (this.props.Customer && this.props.Customer.CustomerNo) {
      customerNoValue = this.props.Customer.CustomerNo;
    }

    // === Construir el request con el contexto actual ===
    var data = {
      company: getValueCookie('Company'),
      companyId: getValueCookie('CompanyId'),
      priceLevel: priceLevelValue,
      Component: this.props.Component ? this.props.Component : null,
      CustomerNo: customerNoValue
    };

    try {
      // Update sync message
      this.props.Padre.setState({ syncItemsStatus: 'started' });

      // 1) Fetch principal
      var respuesta = await getInformationWithData('/Items/getListV2', data);

      // 2) Lógica especial para CompanyId === '6' (MY/ALT)
      if (getValueCookie('CompanyId') === '6') {
        data.company = 'Mayaland Atlanta';
        data.companyId = '3';
        var respuesta2 = await getInformationWithData('/Items/getListV2', data);

        for (var k = 0; k < respuesta2.data.length; k++) {
          var it2 = respuesta2.data[k];
          if (it2.UnitPriceALT || it2.UnitPriceALT === 0) {
            var calculateFinalPrice = this.setAltPrice(it2);
            it2.UnitPrice = Number(pricesFormat(calculateFinalPrice));
          } else {
            it2.UnitPrice = 0;
          }
        }

        respuesta.status.code = respuesta2.status.code;

        var prodMayalandToInclude = [];
        for (var r = 0; r < respuesta2.data.length; r++) {
          var item2 = respuesta2.data[r];
          item2.IdCompany = 3;
          var idx = getIndexElement(respuesta.data, 'itemCode', item2.itemCode);
          if (idx !== -1) {
            respuesta.data.splice(idx, 1);
            prodMayalandToInclude.push(item2);
          }
        }

        var acceptProductLines = [{ ProdLine: '2012' }, { ProdLine: '2013' }, { ProdLine: '2014' }];
        for (var m = respuesta.data.length - 1; m >= 0; m--) {
          var item = respuesta.data[m];
          item.IdCompany = 6;
          var prodIndex = getIndexElement(acceptProductLines, 'ProdLine', item.ProductLine);
          if (prodIndex !== -1) {
            if (item.UnitPriceALT || item.UnitPriceALT !== 0) {
              item.UnitPrice = Number(pricesFormat(item.UnitPriceALT));
            }
          } else {
            respuesta.data.splice(m, 1);
          }
        }

        if (data.priceLevel !== '2') {
          respuesta.data = respuesta.data.concat(prodMayalandToInclude);
        } else {
          respuesta.data = prodMayalandToInclude;
        }

        var pattern = /talpa/i;
        if (this.props.Customer && this.props.Customer.CustomerName && pattern.test(this.props.Customer.CustomerName)) {
          var updatedTalpaCatalog = await this.setTalpaPrice(respuesta.data);
          this.setState({ talpaCatalog: updatedTalpaCatalog });
        }
      }

      if (!respuesta || !respuesta.status || respuesta.status.code !== 1) {
        console.log(respuesta);
        // Si el servidor no responde bien, no hacemos cache
        return;
      }

      // 3) Construir el arreglo final (igual que en tu getProductsWithProductLine)
      var Padre = this.props.Padre;
      var Products = Padre && Padre.state ? Padre.state[this.props.Array] : [];

      var allProducts = [];
      var allProductLine = [];
      allProductLine.push(new productLine('All'));

      var fullCatalog = respuesta.data;
      if (this.state.talpaCatalog && this.state.talpaCatalog.length > 0) {
        fullCatalog = this.state.talpaCatalog;
      }

      for (var i = 0; i < fullCatalog.length; i++) {
        var it = fullCatalog[i];
        it.ProductLineDesc = it.ProductLineDesc !== 'TALPA' ? it.ProductLineDesc : 'TLP';

        var index1 = getIndexElement(allProductLine, 'ProductLineName', it.ProductLineDesc !== 'TALPA' ? it.ProductLineDesc : 'TLP');
        var index2 = getIndexElement(allProducts, 'itemCode', it.itemCode);
        var index3 = getIndexElement(Products, 'itemCode', it.itemCode);

        if (index1 === -1) {
          allProductLine.push(new productLine(it.ProductLineDesc !== 'TALPA' ? it.ProductLineDesc : 'TLP'));
        }

        if (index2 === -1) {
          var inputvalue = 0;
          if (index3 !== -1) {
            if (this.props.nombrePadre === 'SalesOrder') {
              inputvalue = Products[index3].quantityOrdered;
            } else if (this.props.nombrePadre === 'Invoice') {
              inputvalue = Products[index3].quantityShipped;
            } else if (this.props.nombrePadre === 'ReturnPO') {
              inputvalue = Products[index3].QuantityReturned;
            } else if (this.props.nombrePadre === 'PurchaseOrder') {
              if (this.props.State === '' || this.props.State === '1') {
                inputvalue = Products[index3].quantityOrdered;
              } else {
                inputvalue = Products[index3].quantityReceived ? Products[index3].quantityReceived : 0;
              }
            }
          }

          var description = (it.completeDesc && it.completeDesc !== "null") ? it.completeDesc : it.abbreviatedDesc;
          var newUnitPrice = it.UnitPrice;
          var isPriceBelowCost = it.UnitPrice < it.LastTotalUnitCost;
          var isMYToALT = getValueCookie('CompanyId') === '3' && this.props.Customer && this.props.Customer.CustomerNo === '0016027';

          if (isPriceBelowCost || isMYToALT) {
            newUnitPrice = it.LastTotalUnitCost / 0.95;
          }

          allProducts.push(new Item(
            it.itemCode,
            description,
            it.upc,
            it.quantity,
            it.ShipWeight,
            it.StandardUnitCost,
            it.LastTotalUnitCost,
            newUnitPrice,
            it.ProductLine,
            it.ProductLineDesc,
            it.upc2,
            it.caseupc,
            it.itemURLImageThumb || it.itemURLImage,
            inputvalue,
            it.IdCompany
          ));
        }
      }

      // 4) Guardar cache (sin tocar la UI)
      this.saveOfflineProducts(cacheKey, allProducts);
      // console.log(fullCatalog[0])
      // Set offline thumbs
      const urls = fullCatalog
        .map(it => it.itemURLImageThumb || it.itemURLImage)
        .filter(Boolean);

      const reg = await navigator.serviceWorker.ready;
      const sw = reg.active;
      if (sw) sw.postMessage({ type: 'PRECACHE_THUMBS', urls });

      // (Opcional) Si aún no tienes catálogo en memoria
      if (!this.state || !this.state.Catalogo || this.state.Catalogo.length === 0) {
        this.setState({
          Catalogo: allProducts,
          ProductsInSearch: allProducts,
          ProductLine: allProductLine,
          ProductLineMostrados: allProductLine
        });
      }

      // Update sync message
      this.props.Padre.setState({ syncItemsStatus: 'done' });
    } catch (e) {
      // Silencioso; no bloquear la UI por precarga
      console.error('Prefetch products failed', e);
    }
  };


  // Get products with offline / online validation
  async getProductsWithProductLine(refresh) {
    this.handleModalOpen();
    this.ModalLoading.current.showState(true);

    var cacheKey = this.buildProductsCacheKey(this.props); // tu función actual
    var cached = this.loadOfflineProducts(cacheKey);

    // El cache es válido SOLO si: edad OK Y forma OK
    var cacheValid = this.hasValidCacheAge(cacheKey) && this.isProductShapeValid(cached);

    // Decidir uso offline
    var useOffline = this.shouldUseOffline(this.props.isOnline, refresh, cacheValid);

    console.log('[CATALOG DECISION]', {
      isOnline: this.props.isOnline,
      refresh: !!refresh,
      cacheValid: cacheValid,
      useOffline: useOffline,
      cachedCount: cached ? cached.length : 0
    });

    if (useOffline && cached && cached.length > 0) {
      console.log('Using OFFLINE cache');
      // Si tu UI requiere instancias de Item, rehidrata aquí.
      // Si acepta objetos planos, puedes usar cached tal cual.
      this.setState(
        { Catalogo: cached, ProductsInSearch: cached },
        () => {
          this.ResetPaginationFromList(cached); // evita timing de setState
          this.ModalLoading.current.showState(false);
        }
      );
      return;
    }

    // O no hay internet + cache inválido, o hay internet pero se pidió refresh o cache inválido/expirado
    if (!this.props.isOnline) {
      console.warn('Offline WITHOUT a valid cache. Nothing to show.');
      // Puedes mostrar una alerta amable si quieres
      this.ModalLoading.current.showState(false);
      return;
    }

    // 3) si hay internet, y corresponde recargar (condición original)
    if (this.props.isOnline) {
      console.log(" - 3")
      if (refresh || this.state.Catalogo.length <= 0 || this.state.oldPriceLevel !== this.props.PriceLevel || this.props.Customer.CustomerNo !== this.state.oldCustomerNo) {
        console.log(" - 4")
        this.getCustomerNo();
        this.clearAll();

        var data = {
          company: getValueCookie('Company'),
          companyId: getValueCookie('CompanyId'),
          priceLevel: this.getPriceLevel(),
          Component: this.props.Component ? this.props.Component : null,
          CustomerNo: this.props.Customer && this.props.Customer.CustomerNo ? this.props.Customer.CustomerNo : null
        };

        // Update sync message
        this.props.Padre.setState({ syncItemsStatus: 'started' });

        // Llamada principal
        var respuesta = await getInformationWithData('/Items/getListV2', data);

        if (getValueCookie('CompanyId') === '6') {
          data.company = 'Mayaland Atlanta';
          data.companyId = '3';
          var respuesta2 = await getInformationWithData('/Items/getListV2', data);

          for (var k = 0; k < respuesta2.data.length; k++) {
            var it2 = respuesta2.data[k];
            if (it2.UnitPriceALT || it2.UnitPriceALT === 0) {
              var calculateFinalPrice = this.setAltPrice(it2);
              it2.UnitPrice = Number(pricesFormat(calculateFinalPrice));
            } else {
              it2.UnitPrice = 0; // eliminar del catálogo
            }
          }

          respuesta.status.code = respuesta2.status.code;

          // mezclar catálogos según la lógica original
          var prodMayalandToInclude = [];
          for (var r = 0; r < respuesta2.data.length; r++) {
            var item2 = respuesta2.data[r];
            item2.IdCompany = 3;
            var idx = getIndexElement(respuesta.data, 'itemCode', item2.itemCode);
            if (idx !== -1) {
              respuesta.data.splice(idx, 1);
              prodMayalandToInclude.push(item2);
            }
          }

          var acceptProductLines = [{ ProdLine: '2012' }, { ProdLine: '2013' }, { ProdLine: '2014' }];

          for (var m = respuesta.data.length - 1; m >= 0; m--) {
            var item = respuesta.data[m];
            item.IdCompany = 6;
            var prodIndex = getIndexElement(acceptProductLines, 'ProdLine', item.ProductLine);
            if (prodIndex !== -1) {
              if (item.UnitPriceALT || item.UnitPriceALT !== 0) {
                item.UnitPrice = Number(pricesFormat(item.UnitPriceALT));
              }
            } else {
              respuesta.data.splice(m, 1);
            }
          }

          if (data.priceLevel !== '2') {
            respuesta.data = respuesta.data.concat(prodMayalandToInclude);
          } else {
            respuesta.data = prodMayalandToInclude;
          }

          // Checar si el customer es Talpa
          var pattern = /talpa/i;
          if (this.props.Customer && this.props.Customer.CustomerName && pattern.test(this.props.Customer.CustomerName)) {
            var updatedTalpaCatalog = await this.setTalpaPrice(respuesta.data);
            this.setState({ talpaCatalog: updatedTalpaCatalog });
          }
        }

        if (respuesta && respuesta.status && respuesta.status.code === 1) {
          var Padre = this.props.Padre;
          var Products = Padre.state[this.props.Array];

          // Se define SIEMPRE estas variables antes de usarlas
          var allProducts = [];
          var allProductLine = [];
          allProductLine.push(new productLine('All'));

          var fullCatalog = respuesta.data;
          if (this.state.talpaCatalog && this.state.talpaCatalog.length > 0) {
            fullCatalog = this.state.talpaCatalog;
          }

          for (var i = 0; i < fullCatalog.length; i++) {
            var it = fullCatalog[i];
            it.ProductLineDesc = it.ProductLineDesc !== 'TALPA' ? it.ProductLineDesc : 'TLP';

            var index1 = getIndexElement(allProductLine, 'ProductLineName', it.ProductLineDesc !== 'TALPA' ? it.ProductLineDesc : 'TLP');
            var index2 = getIndexElement(allProducts, 'itemCode', it.itemCode);
            var index3 = getIndexElement(Products, 'itemCode', it.itemCode);

            if (index1 === -1) {
              allProductLine.push(new productLine(it.ProductLineDesc !== 'TALPA' ? it.ProductLineDesc : 'TLP'));
            }

            if (index2 === -1) {
              var inputvalue = 0;
              if (index3 !== -1) {
                if (this.props.nombrePadre === 'SalesOrder') {
                  inputvalue = Products[index3].quantityOrdered;
                } else if (this.props.nombrePadre === 'Invoice') {
                  inputvalue = Products[index3].quantityShipped;
                } else if (this.props.nombrePadre === 'ReturnPO') {
                  inputvalue = Products[index3].QuantityReturned;
                } else if (this.props.nombrePadre === 'PurchaseOrder') {
                  if (this.props.State === '' || this.props.State === '1') {
                    inputvalue = Products[index3].quantityOrdered;
                  } else {
                    inputvalue = Products[index3].quantityReceived ? Products[index3].quantityReceived : 0;
                  }
                }

                // PurchaseReturn no modifica inputvalue
              }

              var description = (it.completeDesc && it.completeDesc !== "null") ? it.completeDesc : it.abbreviatedDesc;
              var newUnitPrice = it.UnitPrice;
              var isPriceBelowCost = it.UnitPrice < it.LastTotalUnitCost;
              var isMYToALT = getValueCookie('CompanyId') === '3' && this.props.Customer && this.props.Customer.CustomerNo === '0016027';

              if (isPriceBelowCost || isMYToALT) {
                newUnitPrice = it.LastTotalUnitCost / 0.95;
              }

              allProducts.push(new Item(
                it.itemCode,
                description,
                it.upc,
                it.quantity,
                it.ShipWeight,
                it.StandardUnitCost,
                it.LastTotalUnitCost,
                newUnitPrice,
                it.ProductLine,
                it.ProductLineDesc,
                it.upc2,
                it.caseupc,
                it.itemURLImage,
                inputvalue,
                it.IdCompany
              ));
            }
          }

          var plain = [];
          // console.log('Catalogue 2.0')
          // console.log(allProducts[0])
          for (var f = 0; f < allProducts.length; f++) {
            plain.push(this.toPlainProduct(allProducts[f])); // usa tu mapper plano
          }
          this.saveOfflineProducts(cacheKey, plain);

          // Set offline thumbs
          // const urls = fullCatalog
          // .map(it => it.itemURLImageThumb || it.itemURLImage)
          // .filter(Boolean);

          // const reg = await navigator.serviceWorker.ready;
          // const sw = reg.active;
          // if (sw) sw.postMessage({ type: 'PRECACHE_THUMBS', urls });

          this.setState({
            Catalogo: allProducts,
            ProductsInSearch: allProducts,
            ProductLine: allProductLine,
            ProductLineMostrados: allProductLine
          }, () => {
            this.ResetPaginationFromList(allProducts);
            this.ModalLoading.current.showState(false);
          });

          // Update sync message
          this.props.Padre.setState({ syncItemsStatus: 'done' });
        } else {
          // respuesta fallida
          confirmCloseAlert('incorrect', 'Error retrieving products from server.');
        }

        this.ModalLoading.current.showState(false);
        return;
      } else {
        // Online pero no cumple condición de recarga → mantiene estado actual y paginación
        await this.ResetPagination();
        this.ModalLoading.current.showState(false);
        return;
      }
    }

    // 4) Sin internet y sin cache válido → mensaje suave
    if (!cached || cached.length === 0) {
      console.warn('Offline with no local products cache for key:', cacheKey);
      // opcional:
      // confirmCloseAlert('incorrect', 'No connection and no local catalog available.');
    }

    this.ModalLoading.current.showState(false);
  }

  // Evita leer this.state.ProductsInSearch inmediatamente después de setState
  ResetPaginationFromList(list) {
    // Asegúrate de tener un valor por defecto
    var perPage = 60;
    var totalPages = Math.ceil(list.length / perPage);
    var seeProds = list.slice(0, perPage);

    this.setState({
      ProductosMostrados: seeProds,
      currentPage: 0,
      ProductsPerPage: perPage,
      TotalPages: totalPages
    });

    this.updateInputsCard();
  }

  // Paginate products
  async ResetPagination() {
    console.log("- ResetPagination");
    console.log(this.state.ProductsInSearch.length);
    let totalPages = Math.round(this.state.ProductsInSearch.length / this.state.ProductsPerPage);
    let seeProds = this.state.ProductsInSearch.slice(0, 0 + this.state.ProductsPerPage);

    this.setState({
      ProductosMostrados: seeProds,
      currentPage: 0,
      ProductsPerPage: 60,
      TotalPages: totalPages
    });

    this.updateInputsCard();
  }

  async nextPage() {
    if ((this.state.currentPage + this.state.ProductsPerPage) <= this.state.ProductsInSearch.length) {
      await this.setState({ currentPage: this.state.currentPage + this.state.ProductsPerPage })
    }
    this.updateSeeProducts()
    this.backToTop()
  }

  async prevPage() {
    if (this.state.currentPage > 0) {
      await this.setState({ currentPage: this.state.currentPage - this.state.ProductsPerPage })
    }
    this.updateSeeProducts()
    this.backToTop()
  }

  async updateSeeProducts() {
    let seeProds = this.state.ProductsInSearch.slice(this.state.currentPage, this.state.currentPage + this.state.ProductsPerPage)


    await this.setState({
      ProductosMostrados: seeProds,
    })
    await this.updateInputsCard()
  }

  updateInputsCard() {
    for (const item of this.state.ProductosMostrados) {
      if (document.getElementById('QuantityAdded_' + item.itemCode)) {
        document.getElementById('QuantityAdded_' + item.itemCode).value = item.InputValue
      }
    }
  }

  backToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  render() {
    return (
      <React.Fragment>
        <LoadingWindow ref={this.ModalLoading} />
        <div className="input-group" style={{ marginBottom: 0 }}>
          {this._onOnline ?
            <button hidden={this.props.hidden} disabled={this.props.disabled} type="button" onClick={() => this.refreshThumbsCache()} className={"btn purpleButtonv2 btn-lg"}><FiRefreshCw /> Images Cache</button>
            : null}
          {/* disabled={this.props.disabled} */}
          <button hidden={this.props.hidden} id={this.props.id} disabled={this.props.disabled} type="button" onClick={() => this.getProductsWithProductLine(false)} className={"btn " + this.props.colorButton + " btn-lg"}> <BsJournals /> {this.props.titleButton}</button>
        </div>

        <ModalOrders title={"Catalogue"} show={this.state.showModal} close={() => this.handleModalClose()}>

          <div className='row'>
            <div className="offcanvas offcanvas-start" tabIndex="-1" id="canvasCategory" aria-labelledby="canvasCategorysDet">
              <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="offcanvasExampleLabel">Product Lines</h5>
                <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
              </div>
              <div className="offcanvas-body row">
                <div className='col-sm-12 FixedTitle'>
                  <div className='row  text-start'>
                    <div className='InputTextBolder PrincipalHead col-sm-12 text-center '>

                      <div className="input-group input-group-lg flex-nowrap pt-2">
                        <input className='form-control w-75 display-inline' placeholder='Search by Product Line...' id={'productLineSearch' + this.props.nombrePadre} onKeyUp={this.SearchLineProduct} autoComplete={"off"} />
                        <span className="input-group-addon">
                          <button className='btn greenButton btn-lg' onClick={() => this.getProductsWithProductLine(true)}><BsArrowRepeat /></button>
                        </span>
                      </div>
                    </div>
                    {this.state.ProductLineMostrados.map((element, pL) => (
                      <div data-bs-dismiss="offcanvas" key={pL} onClick={() => this.SelectProductLine(element)} className={'col-sm-12 InputTextBolder2 ' + (element.ProductLineName === this.state.SelectedProdLine ? 'backgroundSky2' : '')}>
                        <p><br />{element.ProductLineName}<br /></p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12  FixedTitle2'>
              <div className='row'>

                <div className='row pt-1 pb-2'>
                  <div className='row d-flex justify-content-center pb-4'>
                    <div className='col-md-10 InputText'>
                      <div className="card shadow">
                        <div className="card-body d-flex justify-content-center">
                          <div className="input-group input-group-lg flex-nowrap">
                            <input className='form-control w-75 display-inline' placeholder='Search by ItemCode, Description...' id={'catalogo_busqueda' + this.props.nombrePadre} onKeyUp={this.buscarProductos} autoComplete={"off"} />
                            <button className="btn blueButton btn-lg" type="button" data-bs-toggle="offcanvas" data-bs-target="#canvasCategory" aria-controls="canvasCategorys"><BsList /></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {
                  this.state.ProductosMostrados.map((producto, i) => (
                    <div key={i} className='col-sm-6 col-md-4 col-lg-4' data-bs-dismiss="modal">
                      <div style={{ border: '1px solid #ccc', borderRadius: 5, margin: 3 }}>
                        <ItemCard State={this.props.State} PriceLevel={this.props.PriceLevel} Padre={this.props.Padre} Array={this.props.Array} nombrePadre={this.props.nombrePadre} objectProd={producto} itemURLImage={producto.itemURLImage} itemURLImageThumb={producto.itemURLImageThumb} ItemCode={producto.itemCode} Description={producto.abbreviatedDesc} OnHand={producto.quantity} UPC={producto.upc} LastTotalUnitCost={producto.LastTotalUnitCost} UnitPrice={producto.UnitPrice} needPrice={this.props.needPrice} needCost={this.props.needCost} isOnline={this.props.isOnline} />
                      </div>
                    </div>
                  ))
                }
              </div>

              <div className='row'>
                <div className='col-sm-12 text-center'>
                  <div className="btn-group btn-group-lg" role="group" aria-label="pagination">
                    <button type="button" onClick={() => this.prevPage()} className="btn blueButton">Prev</button>
                    <button type="button" onClick={() => this.nextPage()} className="btn blueButton">Next</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalOrders>
      </React.Fragment>
    )
  }
}